import { TFilterShareColor } from "@irohana-dev/components";

import { button, primary } from "@/theme/colors";

export const filterConditionShareColor: TFilterShareColor = { bg: primary[800], accent: button.primary };
